"use client";
import GatheringAccessEnum from "src/api/graphql/__generated__/enums/GatheringAccessEnum";
import { GatheringInitialEntryFragmentFragment } from "src/api/graphql/__generated__/graphql";
import GatheringContextWrapper from "src/contexts/GatheringContext/components/GatheringContextWrapper";
import GatheringHome from "src/screens/(internal)/(GatheringHome)/GatheringHome";
import GatheringJoin from "./GatheringJoin";

const GatheringEntryLoggedIn = ({
	gathering,
}: {
	gathering: GatheringInitialEntryFragmentFragment;
}) => {
	if (gathering.access === GatheringAccessEnum.None || !gathering.access) {
		return <GatheringJoin gathering={gathering} />;
	}
	return (
		<GatheringContextWrapper gathering={gathering}>
			<GatheringHome />
		</GatheringContextWrapper>
	);
};

export default GatheringEntryLoggedIn;
